import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

export const firebaseConfig = {
  apiKey: "AIzaSyDAKYIxiXCuJJh4H3m6wAHKMfzbsRk8TJ8",
  authDomain: "hasimoglu-kurban.firebaseapp.com",
  projectId: "hasimoglu-kurban",
  storageBucket: "hasimoglu-kurban.firebasestorage.app",
  messagingSenderId: "105323359874",
  appId: "1:105323359874:web:9095201c14813061014e9b"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;
